import { SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { HC_0136_SALES_HUB_PROFESSIONAL, HC_0136_SERVICE_HUB_PROFESSIONAL } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { HC_0136_GROUP_PARAMETER_KEY, HC_0136_GROUP_PARAMETER_OPTIONS, HC_0136_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useAppSelector } from '../../reducers';
import { hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { getIsAcceptanceTest } from '../testUtils';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { logExperimentExposure, useExperimentEffect } from './experimentUtils';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { useCompanyDetails } from '../../hooks/useCompanyDetails';
import { useIsSeatsUser } from '../../v2/hooks/useUserInfo';
import { useHighestProductLevelFromInventory } from '../../v2/hooks/useProductInventory';
const treatmentKey = HC_0136_TREATMENT_KEY;
export const PROMOTION_MAPPING = {
  [SALES_HUB_PROFESSIONAL]: HC_0136_SALES_HUB_PROFESSIONAL,
  [SERVICE_HUB_PROFESSIONAL]: HC_0136_SERVICE_HUB_PROFESSIONAL
};
export const TRIAL_PROMO_LENGTH = 42 * 24 * 60 * 60 * 1000; // 42 days in ms

export const logHC0136Exposure = () => {
  logExperimentExposure(treatmentKey);
};
const useHC0136EligibilityCondition = apiName => {
  var _companyDetails$compa, _companyDetails$compa2;
  const isAcceptanceTest = getIsAcceptanceTest();
  const hasExperimentsFetchSucceeded = useAppSelector(hasExperimentsFetchSucceededSelector);
  const isAppReady = useGlobalLoading();
  const isInApp = useAppSelector(isAppAuthSelector);
  const {
    companyDetails
  } = useCompanyDetails();
  const hasSeats = useIsSeatsUser();
  const {
    highestProductLevel
  } = useHighestProductLevelFromInventory();
  const isFreeOrStarter = highestProductLevel && ['FREE', 'STARTER'].includes(highestProductLevel);
  const isConditionMet = Boolean(isAppReady && hasExperimentsFetchSucceeded && !isAcceptanceTest && isInApp && hasSeats && isFreeOrStarter && (companyDetails === null || companyDetails === void 0 || (_companyDetails$compa = companyDetails.companyDetails) === null || _companyDetails$compa === void 0 ? void 0 : _companyDetails$compa.companySize) && (companyDetails === null || companyDetails === void 0 || (_companyDetails$compa2 = companyDetails.companyDetails) === null || _companyDetails$compa2 === void 0 ? void 0 : _companyDetails$compa2.companySize) <= 10 && PROMOTION_MAPPING[apiName]);
  return {
    isConditionMet
  };
};
export const useHC0136ExperimentEffect = apiName => {
  const eligibilityCondition = useHC0136EligibilityCondition(apiName);
  return useExperimentEffect({
    treatmentKey: HC_0136_TREATMENT_KEY,
    groupParameterKey: HC_0136_GROUP_PARAMETER_KEY,
    groupParameterOptions: HC_0136_GROUP_PARAMETER_OPTIONS,
    experimentEligibilityCondition: () => eligibilityCondition,
    shouldLogExposure: false
  });
};